// import Cookies from "js-cookie";

// const AQ_BASE_URL = process.env.REACT_APP_AQ_BASE_URL;

// export const refreshAccessToken = async () => {
//   try {
//     const response = await fetch(`${AQ_BASE_URL}/aq/api/refresh_token`, {
//       method: "POST",
//       credentials: 'include', // send cookies (important!)
//       headers: {
//         'Content-Type': 'application/json',
//       },
//     });

//     if (!response.ok) {
//       // Clear anything if token refresh fails
//       Cookies.remove("access_token", { path: '/' });
//       Cookies.remove("refresh_token", { path: '/' });
//       localStorage.removeItem("user");
//       localStorage.removeItem("permissions");
//       throw new Error(`Refresh failed: ${response.status}`);
//     }

//     const data = await response.json();

//     // Optionally cache the user and permissions
//     if (data.user) {
//       localStorage.setItem("user", JSON.stringify(data.user));
//     }

//     if (data.permissions) {
//       localStorage.setItem("permissions", JSON.stringify(data.permissions));
//     }

//     return true;
//   } catch (error) {
//     console.error("Token refresh error:", error);
//     Cookies.remove("access_token", { path: '/' });
//     Cookies.remove("refresh_token", { path: '/' });
//     localStorage.removeItem("user");
//     localStorage.removeItem("permissions");
//     return false;
//   }
// };

// // export const isAuthenticated = async () => {
// //   try {
// //     // For HTTP-only cookies, we need to verify via an API endpoint
// //     const response = await fetch(`${AQ_BASE_URL}/aq/api/verify_token`, {
// //       method: "GET",
// //       credentials: 'include'
// //     });

// //     return response.ok;
// //   } catch (error) {
// //     console.error("Authentication check failed:", error);
// //     return false;
// //   }
// // };

// // export const getUserPermissionsFromToken = () => {
// //   try {
// //     const permissions = JSON.parse(localStorage.getItem("permissions"));
// //     return Array.isArray(permissions) ? permissions : [];
// //   } catch {
// //     return [];
// //   }
// // };

// export const getCurrentUser = async () => {
//   try {
//     const response = await fetch(`${AQ_BASE_URL}/aq/api/currentuser`, {
//       credentials: 'include'
//     });

//     if (!response.ok) {
//       return null;
//     }

//     const userData = await response.json();

//     // Ensure permissions and roles are always arrays
//     return {
//       ...userData,
//       permissions: Array.isArray(userData.permissions) ? userData.permissions : [],
//       roles: Array.isArray(userData.roles) ? userData.roles : []
//     };
//   } catch (error) {
//     console.error("Failed to fetch user data:", error);
//     return null;
//   }
// };

// export const getUserPermissions = async () => {
//   const user = await getCurrentUser();
//   return user?.permissions || [];
// };

// export const isAuthenticated = async () => {
//   try {
//     const response = await fetch(`${AQ_BASE_URL}/aq/api/currentuser`, {
//       credentials: 'include'
//     });
//     return response.ok;
//   } catch (error) {
//     return false;
//   }
// };

// import Cookies from "js-cookie";

// const AQ_BASE_URL = process.env.REACT_APP_AQ_BASE_URL;

// // Cache variables
// let currentUser = null;
// let userFetchPromise = null;
// let lastFetchTime = 0;
// const CACHE_DURATION = 1 * 60 * 1000; // 5 minutes cache

// export const refreshAccessToken = async () => {
//   try {
//     const response = await fetch(`${AQ_BASE_URL}/aq/api/refresh_token`, {
//       method: "POST",
//       credentials: 'include',
//       headers: {
//         'Content-Type': 'application/json',
//       },
//     });

//     if (!response.ok) {
//       clearAuthData();
//       throw new Error(`Refresh failed: ${response.status}`);
//     }
//     console.log(response);
//     const data = await response.json();
//     return true;
//   } catch (error) {
//     console.error("Token refresh error:", error);
//     clearAuthData();
//     return false;
//   }
// };

// export const clearAuthData = () => {
//   Cookies.remove("access_token", { path: '/' });
//   Cookies.remove("refresh_token", { path: '/' });
//   currentUser = null;
//   userFetchPromise = null;
//   lastFetchTime = 0;
// };

// export const fetchWithAuth = async (url, options = {}) => {
//   let response = await fetch(url, {
//     ...options,
//     credentials: 'include'
//   });

//   // If unauthorized, try to refresh token once
//   if (response.status === 401) {
//     const refreshSuccess = await refreshAccessToken();
//     if (refreshSuccess) {
//       // Retry original request with new tokens
//       response = await fetch(url, {
//         ...options,
//         credentials: 'include'
//       });
//     } else {
//       clearAuthData();
//       window.location.href = '/login';
//       throw new Error('Session expired');
//     }
//   }

//   return response;
// };

// export const getCurrentUser = async (forceRefresh = false) => {
//   // Return cached user if available and not expired
//   if (currentUser && !forceRefresh && Date.now() - lastFetchTime < CACHE_DURATION) {
//     return currentUser;
//   }

//   // Return ongoing promise if available
//   if (userFetchPromise && !forceRefresh) {
//     return userFetchPromise;
//   }

// //   try {
// //     userFetchPromise = fetch(`${AQ_BASE_URL}/aq/api/currentuser`, {
// //       credentials: 'include'
// //     }).then(async (response) => {
// //       if (!response.ok) {
// //         clearAuthData();
// //         return null;
// //       }

// //       const userData = await response.json();
// //       currentUser = {
// //         ...userData,
// //         permissions: Array.isArray(userData.permissions) ? userData.permissions : [],
// //         roles: Array.isArray(userData.roles) ? userData.roles : []
// //       };
// //       lastFetchTime = Date.now();
// //       return currentUser;
// //     });

// //     return await userFetchPromise;
// //   } catch (error) {
// //     console.error("Failed to fetch user data:", error);
// //     return null;
// //   } finally {
// //     userFetchPromise = null;
// //   }
// // };
// try {
//   userFetchPromise = fetchWithAuth(`${AQ_BASE_URL}/aq/api/currentuser`)
//     .then(async (response) => {
//       if (!response.ok) {
//         if (response.status === 401) {
//           clearAuthData();
//         }
//         return null;
//       }

//       const userData = await response.json();
//       currentUser = {
//         ...userData,
//         permissions: Array.isArray(userData.permissions) ? userData.permissions : [],
//         roles: Array.isArray(userData.roles) ? userData.roles : []
//       };
//       lastFetchTime = Date.now();
//       return currentUser;
//     });

//   return await userFetchPromise;
// } catch (error) {
//   console.error("Failed to fetch user data:", error);
//   return null;
// } finally {
//   userFetchPromise = null;
// }
// };

// export const isAuthenticated = async () => {
//   const user = await getCurrentUser();
//   return !!user;
// };

// export const getUserPermissions = async () => {
//   const user = await getCurrentUser();
//   return user?.permissions || [];
// };

import Cookies from 'js-cookie';

const AQ_BASE_URL = process.env.REACT_APP_AQ_BASE_URL;

// Cache variables
let currentUser = null;
let userFetchPromise = null;
let lastFetchTime = 0;
const CACHE_DURATION = 30 * 60 * 1000; // 30 minutes cache for user data

// Token management
let tokenExpirationTime = 0;
let refreshTokenExpirationTime = 0;
let refreshInProgress = null; // Stores the active refresh promise

// Set token expiration times
export const setTokenExpiration = (accessTokenExpiresIn, refreshTokenExpiresIn) => {
  tokenExpirationTime = Date.now() + accessTokenExpiresIn * 1000;
  refreshTokenExpirationTime = Date.now() + refreshTokenExpiresIn * 1000;
};

// Check if access token needs refresh (with 1 minute buffer)
export const isAccessTokenExpired = () => {
  return Date.now() >= tokenExpirationTime - 60000;
};

// Check if refresh token has expired
export const isRefreshTokenExpired = () => {
  return Date.now() >= refreshTokenExpirationTime;
};

// Refresh access token with single-flight guarantee
export const refreshAccessToken = async () => {
  if (refreshInProgress) {
    return refreshInProgress;
  }

  try {
    refreshInProgress = fetch(`${AQ_BASE_URL}/aq/api/refresh_token`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
    }).then(async (response) => {
      if (!response.ok) {
        clearAuthData();
        throw new Error(`Refresh failed: ${response.status}`);
      }

      const data = await response.json();

      // ⚡ Check if expires_in exists
      if (data.expires_in && data.refresh_expires_in) {
        setTokenExpiration(data.expires_in, data.refresh_expires_in);
      } else {
        // ⚡ If server says "Access token still valid", do nothing
        console.info('Access token was already valid. No refresh needed.');
      }

      return true;
    });

    const result = await refreshInProgress;
    return result;
  } catch (error) {
    console.error('Token refresh error:', error);
    clearAuthData();
    throw error;
  } finally {
    refreshInProgress = null;
  }
};

// Clear authentication data
export const clearAuthData = () => {
  Cookies.remove('access_token', { path: '/' });
  Cookies.remove('refresh_token', { path: '/' });
  Cookies.remove('access_token_expiration', { path: '/' });
  Cookies.remove('refresh_token_expiration', { path: '/' });

  currentUser = null;
  userFetchPromise = null;
  lastFetchTime = 0;
  tokenExpirationTime = 0;
  refreshTokenExpirationTime = 0;
};

// Fetch with authentication
export const fetchWithAuth = async (url, options = {}) => {
  if (isAccessTokenExpired()) {
    try {
      await refreshAccessToken();
    } catch (error) {
      clearAuthData();
      window.location.href = '/login';
      throw new Error('Session expired');
    }
  }

  let response = await fetch(url, {
    ...options,
    credentials: 'include',
  });

  if (response.status === 401) {
    try {
      await refreshAccessToken();
      response = await fetch(url, {
        ...options,
        credentials: 'include',
      });

      // ⚡ After second fetch, check again
      if (response.status === 401) {
        clearAuthData();
        window.location.href = '/login';
        throw new Error('Session expired after refresh');
      }
    } catch (error) {
      clearAuthData();
      window.location.href = '/login';
      throw new Error('Session expired');
    }
  }

  return response;
};

// Get current user data
export const getCurrentUser = async (forceRefresh = false) => {
  if (currentUser && !forceRefresh && Date.now() - lastFetchTime < CACHE_DURATION) {
    return currentUser;
  }

  if (userFetchPromise && !forceRefresh) {
    return userFetchPromise;
  }

  try {
    userFetchPromise = fetchWithAuth(`${AQ_BASE_URL}/aq/api/currentuser`).then(async (response) => {
      if (response.status === 401 || response.status === 404) {
        try {
          await refreshAccessToken();
          return getCurrentUser(true);
        } catch (error) {
          clearAuthData();
          window.location.href = '/login';
          throw error;
        }
      }

      if (!response.ok) {
        if (response.status === 401) {
          clearAuthData();
        }
        return null;
      }

      const userData = await response.json();
      currentUser = {
        ...userData,
        property_id: userData.property_id,
        permissions: Array.isArray(userData.permissions) ? userData.permissions : [],
        roles: Array.isArray(userData.roles) ? userData.roles : [],
      };
      lastFetchTime = Date.now();
      return currentUser;
    });

    return await userFetchPromise;
  } catch (error) {
    console.error('Failed to fetch user data:', error);
    return null;
  } finally {
    userFetchPromise = null;
  }
};

// Check if user is authenticated
export const isAuthenticated = async () => {
  const user = await getCurrentUser();
  return !!user;
};

// Get user permissions
export const getUserPermissions = async () => {
  const user = await getCurrentUser();
  return user?.permissions || [];
};
